module.exports = __webpack_public_path__ + "img/av234.51193301.png";